// text "ПРИЕМ СТАВОК ВРЕМЕННО ПРИОСТАНОВЛЕН" will follow scroll
var BinderTextScroll = window.BinderTextScroll = (function () {
    interface IListenersType {
        [key: number]: {
            now: () => void | null,
            after: () => void | null,
        };
    }

    const listeners: IListenersType = {}; // save scroll eventListeners here

    function throttle(fn: () => void, wait: number) {
        let time = Date.now();
        return () => {
            if ((time + wait - Date.now()) < 0) {
                fn();
                time = Date.now();
            }
        };
    }

    function bindScroll(coefsNode: JQuery) {
        const el = coefsNode[0]; // get native element from jquery
        const rect = el.getBoundingClientRect();
        const eventId = parseInt(el.dataset.eventId, 10);

        if (rect.height < window.innerHeight) {
            return;
        }

        const elText: HTMLParagraphElement = el.querySelector(".events-table__row-blocked-text");
        elText.style.top = "10%";

        const throttledMoveText = throttle(moveText.bind(null, el), 300);
        const moveTextAfterScrollEnds = moveText.bind(null, el);

        listeners[eventId] = {
            after: null,
            now: null,
        };
        listeners[eventId].now = throttledMoveText;
        listeners[eventId].after = moveTextAfterScrollEnds;

        window.addEventListener("scroll", throttledMoveText);
        window.addEventListener("scroll", moveTextAfterScrollEnds);
    }

    function unbindScroll(eventId: number) {
        if (!!listeners[eventId]) {
            window.removeEventListener("scroll", listeners[eventId].now);
            window.removeEventListener("scroll", listeners[eventId].after);
            delete listeners[eventId];
        }
    }

    function moveText(el: HTMLDivElement) {
        if (isScrolledIntoView(el)) {
            const text: HTMLParagraphElement = el.querySelector(".events-table__row-blocked-text");
            const parentRect = el.getBoundingClientRect();

            if (parentRect.top < parentRect.height * (-1) + window.innerHeight / 2 + text.offsetHeight * 2) {
                text.classList.remove("m-fixed");
                text.style.top = "90%";
            } else if (parentRect.top < 200) {
                text.classList.add("m-fixed");
                text.style.top = "50%";
            } else {
                text.classList.remove("m-fixed");
                text.style.top = "10%";
            }
        }
    }

    function isScrolledIntoView(eventNodeCoefs: HTMLDivElement) {
        const rect = eventNodeCoefs.getBoundingClientRect();
        const elementTop = rect.top;
        const elementBottom = rect.bottom;
        const isVisible = elementTop < window.innerHeight && elementBottom >= 0;
        return isVisible;
    }

    return {
        bindScroll,
        unbindScroll
    }
}());
